export default __webpack_public_path__ + "static/media/634.f961d2d3.jpg";